<template>
  <div>
    <Card
      :title="sectionTitle + ' - ' + titleAdd"
    >
      <template v-slot:button>
        <Button variant="primary" @clicked="showModal = true" label="Add Content"/>
      </template>
      <template v-slot:body>
        <el-table-draggable @sort="onSort"  handle=".handle-move"  v-if="data.length > 0" >
          <el-table :data="data" row-key="id" :show-header="true" style="width: 100%">
            <el-table-column label="" align="left" key="handle" width="100px">
              <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                <font-awesome-icon size="2x" :icon="['fa', 'th']" />
              </div>
            </el-table-column>
            <el-table-column label="Title" align="left" v-if="sectionType === 'song'" prop="title"></el-table-column>
            <el-table-column label="Playlist Title" align="left" v-if="sectionType === 'playlist'" prop="title"></el-table-column>
            <el-table-column label="Artist Name" align="left" v-if="sectionType === 'song'" prop="name"></el-table-column>
            <el-table-column label="Album Name" align="left" v-if="sectionType === 'album'" prop="name"></el-table-column>
            <el-table-column label="Artist Name" align="left" v-if="sectionType === 'artist'" prop="name"></el-table-column>
            <el-table-column label="Actions" align="right">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                  <VueCustomTooltip label="Delete" :position="'is-left'">
                    <button @click="deleteContent(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-table-draggable>
        <div class="flex justify-center py-6" v-if="data.length === 0">
          No content added. Please add a content to continue
        </div>
      </template>
    </Card>
    <ModalDialog
      ref="addSong"
      size="large"
      :isShowingModal="showModal"
      :title="'Add '+titleAdd"
      @toggleModal="showModal = !showModal"
      :labelSubmit="'Submit'"
      @save="submitAddContent()" >
      <template slot="body" >
        <SearchSong v-if="sectionType === 'song'" ref="addSongContent"  @on-remove-song="onRemoveFromSearch" @on-submit-song="addContentBulk" :toggle-reset="showModal"  :taken-song="data"></SearchSong>
        <SearchAlbum v-if="sectionType === 'album'" ref="addAlbumContent"  @on-remove-album="onRemoveFromSearch" @on-submit-album="addContentBulk" :toggle-reset="showModal"  :taken-album="data"></SearchAlbum>
        <SearchArtist v-if="sectionType === 'artist'" ref="addArtistContent"  @on-remove-artist="onRemoveFromSearch" @on-submit-artist="addContentBulk" :toggle-reset="showModal"  :taken-artist="data"></SearchArtist>
        <SearchPlaylist v-if="sectionType === 'playlist'" ref="addPlaylistContent"  @on-remove-playlist="onRemoveFromSearch" @on-submit-playlist="addContentBulk" :toggle-reset="showModal"  :taken-playlist="data"></SearchPlaylist>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ElTableDraggable from 'el-table-draggable';
import Vue from 'vue';
import axios from 'axios';
import SearchSong from '../Playlist/SearchSong';
import SearchAlbum from './SearchAlbum';
import SearchArtist from './SearchArtist';
import SearchPlaylist from './SearchPlaylist';
import { Button, FormItem, Input, TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';

export default {
  name: 'HomeSectionDetail',
  data() {
    return {
      sectionId: Number(this.$route.params.sectionId),
      sectionType: null,
      sectionTitle: null,
      data: [],
      isContentEmpty: false,
      showModal: false,
      showModalArtist: false,
      showModalAlbum: false,
      tableColumn: [
        {
          prop: 'name',
          label: 'Name',
        },
      ],
    };
  },
  computed: {
    titleAdd() {
      switch (this.sectionType) {
        case 'artist':
          return 'Artist';
        case 'album':
          return 'Album';
        case 'song':
          return 'Song';
        case 'playlist':
          return 'Playlist';
      }
    },
  },
  async mounted() {
    const section = await this.getData();
    this.sectionType = section.type;
    this.sectionTitle = section.title;
  },
  methods: {
    ...mapActions('HomeSectionModule', ['requestDetailSection', 'requestAddContent',
      'requestDeleteContent', 'requestReorderContent']),
    async getData() {
      const section = await this.requestDetailSection(this.sectionId);
      switch (section.type) {
        case 'artist':
          this.data = section.contents.map(d => ({
            id: d.user_id,
            home_section_content_id: d.home_section_content_id,
            name: d.name,
          }));
          break;
        case 'album':
          this.data = section.contents.map(d => ({
            id: d.album_id,
            home_section_content_id: d.home_section_content_id,
            name: d.name,
          }));
          break;
        case 'song':
          this.data = section.contents.map(d => ({
            id: d.music_id,
            home_section_content_id: d.home_section_content_id,
            title: d.title,
            name: d.name,
          }));
          break;
        case 'playlist':
          this.data = section.contents.map(d => ({
            id: d.playlist_id,
            home_section_content_id: d.home_section_content_id,
            title: d.title,
          }));
          break;
      }
      return section;
    },
    submitAddContent() {
      switch (this.sectionType) {
        case 'artist':
          this.$refs.addArtistContent.submit();
          break;
        case 'album':
          this.$refs.addAlbumContent.submit();
          break;
        case 'song':
          this.$refs.addSongContent.submit();
          break;
        case 'playlist':
          this.$refs.addPlaylistContent.submit();
          break;
      }
    },
    async addContentBulk(data) {
      this.showModal = false;
      if (data.length > 0) {
        // this.setLoading();
        this.data = await Promise.all(data.map(async (content) => {
          await this.requestAddContent({ sectionId: this.sectionId,
            data: {
              reference_id: content.id,
            },
          });
          return content;
        }));
        // this.unsetLoading();
      } else {
        this.data = [];
      }
      this.showModal = false;
    },
    async removeFromList(row) {
      const data = this.data.find(d => d.id === row.id);
      if (data.home_section_content_id) {
        await this.requestDeleteContent(data.home_section_content_id);
        await this.getData();
      }
    },
    async onRemoveFromSearch(id) {
      const data = this.data.find(d => d.id === id);
      if (data.home_section_content_id) {
        await this.requestDeleteContent(data.home_section_content_id);
        await this.getData();
      }
    },
    async onSort(evt) {
      setTimeout(async () => {
        const ids = this.data.map(play => play.home_section_content_id);
        await this.requestReorderContent({ sectionId: this.sectionId, data: { id: ids } });
      }, 500);
    },
    async deleteContent(data) {
      let label = '';
      let name = '';
      switch (this.sectionType) {
        case 'artist':
          label = 'artist content';
          name = data.name;
          break;
        case 'album':
          label = 'album content';
          name = data.name;
          break;
        case 'song':
          label = 'song content';
          name = data.title;
          break;
        case 'playlist':
          label = 'playlist content';
          name = data.title;
          break;
      }
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete ${label}: ${name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteContent(data.home_section_content_id);
          await this.getData();
          this.$swal('Deleted', `You successfully ${label}: ${name}`, 'success');
        }
      });
    },
  },
  components: { SearchPlaylist, ModalDialog, VueCustomTooltip, SearchSong, SearchAlbum, SearchArtist, ElTableDraggable, Button,
    Card,
    FormItem, Input, TextError },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/AppSetting/HomeSectionDetail.vue